import { Controller } from "@hotwired/stimulus"

// A person sitting in a seat slot: a guest, or a guest's plus-one (plusOne).
// While plus-ones are kept with their guest (the seating editor's switch),
// moving the guest brings their plus-one; moving the plus-one moves only them. The identifier is the Sortable draggable selector and the values are read
// by table_card_controller (move to another seat, at any table) and
// sortable_controller (drop back on the unassigned list). Sortable handles
// draggability; see guest_card_controller for why there's no draggable="true"
// here.
export default class extends Controller {
  static values = { assignmentId: Number, guestId: Number, plusOne: Boolean }
}
